import { Controller } from "@hotwired/stimulus"

const image = (height) =>
  `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 ${height}' %3E%3Cline x1='0' x2='1' y1='${height}' y2='${height}' stroke='rgba(255, 0, 0, 0.5)' /%3E%3C/svg%3E")`

const size = (height) =>
  `1px ${height}px`

export default class extends Controller {
  static values = { height: Number }

  connect () {
    const { style } = document.body

    if (this.element.checked) {
      style.setProperty("background-image", image(this.heightValue))
      style.setProperty("background-size", size(this.heightValue))
    } else {
      style.removeProperty("background-image")
      style.removeProperty("background-size")
    }
  }
}
